import React, { useEffect } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text, MessageType } from "@izettle/react"

import { Disclaimer } from "@/components/disclaimer"
import { PageWrapper } from "@/components/layout-helpers"
import { Message } from "@/components/message"
import { useSetPageTitle } from "@/components/page-title"
import { SellerType, Purpose, PurposesContent } from "@/models"

import { PurposeList } from "./purpose-list"

const PageTitle = styled(Text.Title1)`
  margin-bottom: ${spacing.xxSmall};
  margin-top: ${spacing.none};
`

const PageText = styled(Text.Regular)`
  margin-top: ${spacing.none};
  margin-bottom: ${spacing.xxSmall};
`

const StyledMessage = styled(Message)`
  margin-top: ${spacing.xxSmall};
  margin-bottom: ${spacing.xxSmall};
`

type OverviewProps = {
  paypalTheme: boolean
  taskRejected: boolean
  purposes: Purpose[]
  purposesContent: PurposesContent
  sellerType: SellerType
}

export const Overview: React.FC<OverviewProps> = ({
  taskRejected,
  purposes,
  purposesContent,
  sellerType,
  paypalTheme,
}) => {
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()

  useEffect(() => {
    setPageTitle(undefined)
  }, [])

  return (
    <PageWrapper>
      <PageTitle>{text("PURPOSES_HEADING")}</PageTitle>
      <PageText>{text("PURPOSES_INTRO_TEXT")}</PageText>
      {taskRejected && (
        <StyledMessage
          showIcon
          title={text("REJECTED_TITLE")}
          type={MessageType.WARNING}
          ariaLive="assertive"
        >
          {text("REJECTED_TEXT")}
        </StyledMessage>
      )}
      <PurposeList
        purposes={purposes}
        purposesContent={purposesContent}
        sellerType={sellerType}
        paypalTheme={paypalTheme}
      />
      <Disclaimer />
    </PageWrapper>
  )
}
